import styled from 'styled-components';

export const SelectContainer = styled.div`
  display: block;

  position: relative;
  margin-top: 40px;
  box-sizing: border-box;

  .arrow-select {
    position: absolute;
    top: 36px;
    right: 12px;
    z-index: 1;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: bold;
    color: ${({ disabled }) => (disabled ? '#848484' : '#4d4d4d;')};
    letter-spacing: 0.032px;
  }

  select {
    appearance: none;
    line-height: 1.1;
    padding: 8px 16px;
    line-height: 24px;

    width: 100%;
    border: 1px solid ${({ isError }) => (isError ? '#B91C1C' : '#848484')};
    background-color: transparent;
    border-radius: 4px;
    color: #4d4d4d;
    transition: 0.2s;
    outline: 0;
    font-size: 16px;
    letter-spacing: 0.032px;
    transition: 0.3s;
    z-index: 1;
    display: grid;
    min-height: 38px;

    box-sizing: border-box;

    &:focus {
      border: 1px solid ${({ tema }) => tema?.primaryColor};
    }

    &:disabled {
      cursor: not-allowed;
      background-color: #e8e8e8;
      color: #848484;
      opacity: 1;
    }

    option {
      font-size: 120%;
    }

    option:checked {
      background: #bfd7ff;
    }
  }

  .hasValue {
    padding-left: 30px;
  }

  .hasValue:checked {
    color: red;
  }

  .checked-radio {
    position: absolute;
    top: 38px;
    left: 8px;

    pointer-events: none;
    z-index: 1;

    &:checked {
      accent-color: ${({ tema }) => tema?.primaryColor};
    }
  }

  .errorMessage {
    color: #b91c1c;
    margin-top: 8px;
    font-size: 13px;
    height: 14px;
  }
`;
